// Citation Checker バージョンログ
export const versionLog = [
  {
    version: "v1.4.0",
    date: "2026-05-31",
    changes: [
      "形態素解析による引用解析の高精度化",
      "日本語: kuromojin による著者名・タイトル抽出",
      "英語: wink-nlp による固有名詞・品詞タグ付け",
      "構造化形式: Citation.js によるBibTeX/DOI対応",
      "日本心理学会APA形式に対応（全角スペース区切り、全角括弧）",
      "全角スペースによるタイトル・雑誌名の区切り検出",
      "全角括弧（）の巻号表記に対応",
      "API-based解析とregex-basedフォールバック",
      "Claude Code推奨設定の更新"
    ]
  },
  {
    version: "v1.3.1",
    date: "2025-07-18",
    changes: [
      "入れ子括弧の解析処理を改善",
      "複雑な日本語引用の解析精度向上",
      "英語括弧()内は削除、日本語括弧「」『』は内容保持"
    ]
  },
  {
    version: "v1.3.0",
    date: "2025-07-17",
    changes: [
      "書籍章の引用形式を大幅改善",
      "編者情報の表示・比較機能追加",
      "サブタイトル分離による精度向上",
      "章タイトル・書籍タイトル別検索リンク",
      "出版社情報の色分け表示",
      "日本語数字周りのスペース正規化"
    ]
  },
  {
    version: "v1.2.0",
    date: "2025-07-16",
    changes: [
      "フローティング進捗表示追加",
      "引用形式の統一性向上",
      "著者名処理の改善"
    ]
  },
  {
    version: "v1.1.0",
    date: "2025-07-14",
    changes: [
      "書籍章検出機能追加",
      "色分け表示機能追加",
      "Node.js環境のアップグレード"
    ]
  },
  {
    version: "v1.0.0",
    date: "2025-07-11",
    changes: [
      "初回リリース",
      "4データベース対応",
      "APA/MLA/Chicago形式対応"
    ]
  }
];